import { useFetchQuery } from '@atlassian/jira-relay-utils/src/services/use-fetch-query/index.tsx';
import type {
	gqlCountCompassComponentsQuery$data,
	gqlCountCompassComponentsQuery$variables,
} from '@atlassian/jira-relay/src/__generated__/gqlCountCompassComponentsQuery.graphql';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY } from './gql';

interface Props {
	skip?: boolean;
}

export const useCountCompassComponents = (props?: Props) => {
	const { skip = false } = props ?? {};

	const cloudId = useCloudId();

	const { data, loading, error } = useFetchQuery<
		gqlCountCompassComponentsQuery$variables,
		gqlCountCompassComponentsQuery$data
	>(
		COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY,
		{
			cloudId,
			query: { fieldFilters: [{ name: 'state', filter: { in: ['ACTIVE'] } }], sort: [] },
		},
		{
			fetchPolicy: 'network-only',
			skip,
		},
	);

	const count =
		data?.compass?.searchComponents?.__typename === 'CompassSearchComponentConnection'
			? data?.compass?.searchComponents?.totalCount
			: null;

	return {
		count,
		loading,
		error,
	};
};
